import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import Shell from '../components/Shell';
import Seo from '../components/Seo';
import { CTA } from '../components/Pieces';
import NetRakshakSlideshow from '../components/NetRakshakSlideshow';
import { siteImages } from '../mock';

export default function NetRakshak() {
  return (
    <Shell>
      <Seo title="NetRakshak"
        description="Safe, controlled and intelligent broadband for BSNL customers — the NetRakshak proposition in seven slides."
        image={siteImages.netRakshak} />

      <section className="bg-[var(--mm-cream)] border-b border-[var(--mm-line)]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 pt-5 md:pt-7 pb-8 md:pb-10">
          <div className="flex items-center gap-1.5 text-xs text-[var(--mm-ink)]/60 mb-3">
            <Link to="/" className="hover:text-[var(--mm-purple)]">Home</Link>
            <ChevronRight className="w-3 h-3" />
            <span className="text-[var(--mm-purple)]">NetRakshak</span>
          </div>
          <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-2">
            <div>
              <h1 className="font-display text-3xl md:text-4xl font-bold text-[var(--mm-ink)] leading-tight">NetRakshak</h1>
              <p className="mt-1.5 text-base md:text-lg text-[var(--mm-ink)]/70">Safe, controlled and intelligent broadband for BSNL customers — the story in seven slides.</p>
            </div>
          </div>
          <div className="mt-5 md:mt-6">
            <NetRakshakSlideshow />
          </div>
        </div>
      </section>

      <CTA title="Ready to explore NetRakshak with your service provider?" primary={{ label: 'Request a briefing', href: '/contact' }} />
    </Shell>
  );
}
